/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { InnerBox } from '../../components/Tutor/style';
import Text from '../Text';
import InputLegend from '../InputLegend';
import CustomSelect from '../CustomSelect';
import CTA from '../CTA';
import {
  DEL_ACTIVITY,
  DEL_ACTIVITY_COPIES,
  UPDATE_ACTIVITY,
} from '../../../app/redux/actions/tutors';
import { MODAL_OPEN } from '../../../app/redux/actions';
import { ModalSelectScormId } from '../Modals/ModalSelectScorm';
import { ModalCreateQuizId } from '../Modals/ModalCreateQuiz';
import { ActivityDetails, BoxTitle, ModelWrapper } from './style';
import { convertDuration } from '../../../utils/common';
import HtmlRaw from '../HtmlRaw';
import { ModalPreviewQuizId } from '../Modals/ModalPreviewQuiz';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import Icon from '../Icon';
import theme from '../../theme';
import { ModalCreateSessionId } from '../Modals/ModalCreateSession';
import Badge from '../Badge';
import {
  EVENT_ACCESS_OPTS,
  EVENT_REGISTRATION_OPTS,
  getLabelByActivityType,
} from '../../../utils/labels';
import Inline from '../Inline';

const ACTIVITY_OPTIONS = [
  {
    value: 'activity_scorm',
    label: 'SCORM',
  },
  {
    value: 'activity_quiz',
    label: 'QUIZ',
  },
];

const EVENT_OPTIONS = [
  {
    value: 'activity_session_virtual_room',
    label: 'Virtuale',
  },
  {
    value: 'activity_session_in_place_room',
    label: 'In presenza',
  },
];

const ActivityBox = ({
  viewMode,
  mediaIsPhone,
  index,
  sections,
  sectionKey,
  activityKey,
  isSupervisor,
  updateActivity,
  delActivity,
  modalOpen,
  isEvent,
  deleteCopies,
}) => {
  const [options, setOptions] = useState([]);
  const [activity, setActivity] = useState({});
  const [data, setData] = useState({});
  const [isMulti, setIsMulti] = useState(false);

  useEffect(() => {
    if (isEvent) setOptions(EVENT_OPTIONS);
    else setOptions(ACTIVITY_OPTIONS);
  }, [isEvent]);

  useEffect(() => {
    if (sections[sectionKey]?.activities && activityKey) {
      setActivity(sections[sectionKey]?.activities[activityKey]);
    }

    const { activities } = sections[sectionKey];
    setIsMulti(
      Object.values(activities).filter((a) => isSession(a.type)).length > 1
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sections, activityKey]);

  useEffect(() => {
    if (Object.keys(activity?.data || {})?.length > 0) setData(activity?.data);
    else setData({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity]);

  const isSession = (type) => {
    const types = [
      'activity_session_virtual_room',
      'activity_session_in_place_room',
    ];
    return types.includes(type);
  };

  return (
    <InnerBox
      className={
        isSession(activity?.type) && activity.order > 0
          ? 'mt-4 mb-4 is-copy'
          : 'mt-4 mb-4'
      }
    >
      <BoxTitle>
        <Text
          type="h2"
          className={
            isMulti && activity?.type !== 'activity_quiz' ? 'is-multi' : ''
          }
        >
          Attività{' '}
          {isEvent ? (activity?.type === 'activity_quiz' ? '2' : '1') : index}
        </Text>
        {data?.title && (
          <Inline columnGap="8px">
            <Text type="b3" className="confirmed">
              Confermata
            </Text>
            <Icon
              type="check-circle-broken"
              stroke={theme().colors.successIcon}
              size={24}
              clickable={false}
            />
          </Inline>
        )}
        {index > 1 && !isSession(activity?.type) && !viewMode && (
          <CTA
            type="tertiary"
            btnText="Elimina"
            icon="trash-01"
            onClick={() => delActivity(sectionKey, activityKey)}
            bottomRight
          />
        )}
        {!viewMode && isSupervisor && isSession(activity?.type) && (
          <>
            {activity?.order > 0 ? (
              <ModelWrapper>
                <Badge type="news">
                  <Text type="b3">Attività da modello</Text>
                </Badge>
                <CTA
                  type="tertiary"
                  btnText="Elimina"
                  icon="trash-01"
                  onClick={() => delActivity(sectionKey, activityKey)}
                />
              </ModelWrapper>
            ) : (
              <ModelWrapper>
                <Badge type="news">
                  <Text type="b3">Attività principale</Text>
                </Badge>
                <CTA
                  type="tertiary"
                  btnText="Usa come modello"
                  icon="copy-07"
                  onClick={() => {
                    modalOpen(ModalCreateSessionId, {
                      sectionKey,
                      activityKey,
                      type: activity?.type,
                      sessionId: data?.id,
                      copyModel: true,
                    });
                  }}
                  disabled={Object.keys(activity?.data).length === 0}
                />
              </ModelWrapper>
            )}
          </>
        )}
      </BoxTitle>
      <ActivityDetails className="first">
        <div>
          <InputLegend
            label="Tipologia attività"
            required
            htmlFor="activity-typology"
          />
          {viewMode || (index > 1 && isEvent) || isMulti ? (
            <Text type="b3">
              {getLabelByActivityType(activity?.type) ?? 'Quiz'}
            </Text>
          ) : (
            <CustomSelect
              size={mediaIsPhone ? 'full' : 's'}
              placeholder="Seleziona"
              onChange={(newValue) =>
                updateActivity(sectionKey, activityKey, 'type', newValue.value)
              }
              options={options}
              selected={options.find((opt) => opt.value === activity?.type)}
              id="activity-typology"
            />
          )}
        </div>
        {activity?.type === 'activity_scorm' ? (
          // SCORM
          <div className="stretch two">
            <InputLegend label="Inserisci attività" required />
            {data?.id ? (
              <div
                className={
                  mediaIsPhone ? 'd-flex flex-col align-start' : 'd-flex g-24'
                }
              >
                <Text type="b3">Pacchetto SCORM_{data?.id}</Text>
                <CTA
                  type="tertiary"
                  btnText="Elimina"
                  icon="trash-01"
                  onClick={() =>
                    updateActivity(sectionKey, activityKey, 'data', {})
                  }
                />
              </div>
            ) : (
              <div
                className={
                  mediaIsPhone ? 'd-flex flex-col align-start' : 'd-flex g-24'
                }
              >
                <CTA
                  btnText="seleziona"
                  onClick={() =>
                    modalOpen(ModalSelectScormId, { sectionKey, activityKey })
                  }
                  fullsize={mediaIsPhone}
                />
                <Text type="b3">Nessuna attività selezionata</Text>
              </div>
            )}
          </div>
        ) : activity?.type === 'activity_quiz' ||
          (index > 1 && isEvent && !activity?.type) ? (
          // QUIZ
          <div className="stretch two">
            <InputLegend label="Inserisci attività" required />
            {data?.title || data?.node_id ? (
              <div className="d-flex g-24">
                <Text type="b3">
                  Quiz {data?.title}_{data?.id}
                </Text>
                {data?.node_id || data?.nid ? (
                  <CTA
                    type="tertiary"
                    btnText="Visualizza"
                    icon="eye"
                    onClick={() =>
                      modalOpen(ModalPreviewQuizId, {
                        id: data.node_id || data?.nid,
                      })
                    }
                  />
                ) : (
                  <CTA
                    type="tertiary"
                    btnText="Modifica"
                    icon="edit-05"
                    onClick={() =>
                      modalOpen(ModalCreateQuizId, {
                        sectionKey,
                        activityKey,
                        tqId: data?.id,
                        editMode: true,
                      })
                    }
                  />
                )}
              </div>
            ) : (
              <div
                className={
                  mediaIsPhone ? 'd-flex flex-col align-start' : 'd-flex g-24'
                }
              >
                <CTA
                  fullsize={mediaIsPhone}
                  btnText="Crea quiz"
                  onClick={() =>
                    modalOpen(ModalCreateQuizId, { sectionKey, activityKey })
                  }
                />
                <Text type="b3">Nessun quiz creato</Text>
              </div>
            )}
          </div>
        ) : isSession(activity?.type) ? (
          // SESSION
          <div className="stretch two">
            <InputLegend label="Inserisci attività" required />
            {data?.title ? (
              <div
                className={
                  mediaIsPhone ? 'd-flex flex-col align-start' : 'd-flex g-24'
                }
              >
                {mediaIsPhone ? (
                  <Text
                    type="b3"
                    onClick={() =>
                      !viewMode &&
                      modalOpen(ModalCreateSessionId, {
                        sectionKey,
                        activityKey,
                        type: activity?.type,
                        sessionId: data?.id,
                      })
                    }
                  >
                    Sessione {data?.title}
                  </Text>
                ) : (
                  <Text type="b3">Sessione {data?.title}</Text>
                )}
                {!mediaIsPhone && !viewMode && (
                  <CTA
                    type="tertiary"
                    btnText="Modifica"
                    icon="edit-05"
                    onClick={() => {
                      modalOpen(ModalCreateSessionId, {
                        sectionKey,
                        activityKey,
                        type: activity?.type,
                        sessionId: data?.id,
                      });
                    }}
                  />
                )}
                {!viewMode && activity?.order === 0 && (
                  <CTA
                    type="tertiary"
                    btnText="Elimina"
                    icon="trash-01"
                    onClick={() => {
                      updateActivity(sectionKey, activityKey, 'data', {});
                      updateActivity(
                        sectionKey,
                        activityKey,
                        'type',
                        undefined
                      );
                      deleteCopies(sectionKey, activityKey, isSupervisor);
                    }}
                  />
                )}
              </div>
            ) : (
              <div
                className={
                  mediaIsPhone ? 'd-flex flex-col align-start' : 'd-flex g-24'
                }
              >
                {!viewMode && (
                  <CTA
                    btnText="Crea"
                    onClick={() =>
                      modalOpen(ModalCreateSessionId, {
                        sectionKey,
                        activityKey,
                        type: activity?.type,
                      })
                    }
                    fullsize={mediaIsPhone}
                  />
                )}
                <Text type="b3">Nessuna attività creata</Text>
              </div>
            )}
          </div>
        ) : null}
      </ActivityDetails>
      {Object.keys(activity?.data || {})?.length > 0 &&
        !data?.date && ( // if date is NOT defined --> quiz
          <ActivityDetails>
            <div>
              <Text type="h3" mb={8}>
                Titolo attività
              </Text>
              <Text type="b3">{data?.title}</Text>
            </div>
            {data?.code && (
              <div>
                <Text type="h3" mb={8}>
                  Codice
                </Text>
                <Text type="b3">{data?.code}</Text>
              </div>
            )}
            {data?.percentage && (
              <div>
                <Text type="h3" mb={8}>
                  Percentuale
                </Text>
                <Text type="b3">{data?.percentage}%</Text>
              </div>
            )}
            {data?.quiz_tentatives > 0 && (
              <div>
                <Text type="h3" mb={8}>
                  Numero di tentativi
                </Text>
                <Text type="b3">{data?.quiz_tentatives}</Text>
              </div>
            )}
            <div>
              <Text type="h3" mb={8}>
                Durata
              </Text>
              <Text type="b3">{convertDuration(data?.duration)}</Text>
            </div>
            <div className="stretch three">
              <Text type="h3" mb={8}>
                Descrizione
              </Text>
              <Text type="b3">
                <HtmlRaw html={data?.description || '-'} />
              </Text>
            </div>
          </ActivityDetails>
        )}
      {data?.title &&
        data?.date && ( // if date is defined --> event session
          <ActivityDetails>
            <div>
              <Text type="h3" mb={8}>
                Titolo attività
              </Text>
              <Text type="b3">{data?.title}</Text>
            </div>
            {data?.date && (
              <div>
                <Text type="h3" mb={8}>
                  Data
                </Text>
                <Text type="b3">{dayjs(data?.date)?.format('DD/MM/YYYY')}</Text>
              </div>
            )}
            {(data?.start_time || data?.end_time) && (
              <div className="d-flex g-48">
                <div>
                  <Text type="h3" mb={8}>
                    Ora inizio
                  </Text>
                  <Text type="b3">{data?.start_time}</Text>
                </div>
                <div>
                  <Text type="h3" mb={8}>
                    Ora fine
                  </Text>
                  <Text type="b3">{data?.end_time}</Text>
                </div>
              </div>
            )}
            <div />
            <div>
              <Text type="h3" mb={8}>
                Registrazione presenze
              </Text>
              <Text type="b3">
                {data?.attendance
                  ? EVENT_REGISTRATION_OPTS.find(
                      (o) => o.value === data.attendance
                    )?.label
                  : '-'}
              </Text>
            </div>
            <div>
              <Text type="h3" mb={8}>
                Tipologia di accesso
              </Text>
              <Text type="b3">
                {data?.access_type
                  ? EVENT_ACCESS_OPTS.find((o) => o.value === data.access_type)
                      ?.label
                  : '-'}
              </Text>
            </div>
            {data?.available_places > 0 && (
              <div>
                <Text type="h3" mb={8}>
                  Posti disponibilli
                </Text>
                <Text type="b3">{data?.available_places}</Text>
              </div>
            )}
            {data?.url && (
              <div>
                <Text type="h3" mb={8}>
                  Link di accesso
                </Text>
                <Text type="b3">{data?.url}</Text>
              </div>
            )}
            {data?.address && (
              <div>
                <Text type="h3" mb={8}>
                  Luogo
                </Text>
                <Text type="b3">{data?.address}</Text>
              </div>
            )}
            <div className="stretch three">
              <Text type="h3" mb={8}>
                Descrizione
              </Text>
              <Text type="b3">
                <HtmlRaw html={data?.description} />
              </Text>
            </div>
          </ActivityDetails>
        )}
    </InnerBox>
  );
};

ActivityBox.propTypes = {
  viewMode: PropTypes.bool,
  isSupervisor: PropTypes.bool,
  isEvent: PropTypes.bool,
  mediaIsPhone: PropTypes.bool,
  index: PropTypes.number,
  sectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  activityKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sections: PropTypes.object,
  updateActivity: PropTypes.func,
  delActivity: PropTypes.func,
  modalOpen: PropTypes.func,
  deleteCopies: PropTypes.func,
};

export default connect(
  (state) => {
    const { sections } = state.tutors.activities;
    const { isSupervisor } = state.user;
    return { sections, isSupervisor };
  },
  (dispatch) => ({
    modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    updateActivity: (secId, actId, field, value) =>
      dispatch({ type: UPDATE_ACTIVITY, secId, actId, field, value }),
    delActivity: (secId, actId) =>
      dispatch({ type: DEL_ACTIVITY, secId, actId }),
    deleteCopies: (sectionKey, activityKey, isSupervisor) =>
      dispatch({
        type: DEL_ACTIVITY_COPIES,
        sectionKey,
        activityKey,
        isSupervisor,
      }),
  })
)(withMediaQueries(ActivityBox));
